/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<rect
				opacity="0.4"
				x="14"
				y="2"
				width="8"
				height="12"
				rx="2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="8"
				height="20"
				rx="2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="8"
				height="20"
				rx="2"
				fill="currentColor"
			/>
			<path
				d="M2 5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.07989 2 5.2 2H6.8C7.92011 2 8.48016 2 8.90798 2.21799C9.28431 2.40973 9.59027 2.71569 9.78201 3.09202C10 3.51984 10 4.07989 10 5.2V18.8C10 19.9201 10 20.4802 9.78201 20.908C9.59027 21.2843 9.28431 21.5903 8.90798 21.782C8.48016 22 7.92011 22 6.8 22H5.2C4.07989 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V5.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 5.2C14 4.07989 14 3.51984 14.218 3.09202C14.4097 2.71569 14.7157 2.40973 15.092 2.21799C15.5198 2 16.0799 2 17.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V10.8C22 11.9201 22 12.4802 21.782 12.908C21.5903 13.2843 21.2843 13.5903 20.908 13.782C20.4802 14 19.9201 14 18.8 14H17.2C16.0799 14 15.5198 14 15.092 13.782C14.7157 13.5903 14.4097 13.2843 14.218 12.908C14 12.4802 14 11.9201 14 10.8V5.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M1.25 5.25C1.25 3.84987 1.25 3.1498 1.52248 2.61502C1.76217 2.14462 2.14462 1.76217 2.61502 1.52248C3.1498 1.25 3.84987 1.25 5.25 1.25H6.75C8.15013 1.25 8.8502 1.25 9.38498 1.52248C9.85538 1.76217 10.2378 2.14462 10.4775 2.61502C10.75 3.1498 10.75 3.84987 10.75 5.25V18.75C10.75 20.1501 10.75 20.8502 10.4775 21.385C10.2378 21.8554 9.85538 22.2378 9.38498 22.4775C8.8502 22.75 8.15013 22.75 6.75 22.75H5.25C3.84987 22.75 3.1498 22.75 2.61502 22.4775C2.14462 22.2378 1.76217 21.8554 1.52248 21.385C1.25 20.8502 1.25 20.1501 1.25 18.75V5.25Z"
				fill="currentColor"
			/>
			<path
				d="M17.25 1.25C15.8499 1.25 15.1498 1.25 14.615 1.52248C14.1446 1.76217 13.7622 2.14462 13.5225 2.61502C13.25 3.1498 13.25 3.84987 13.25 5.25V10.75C13.25 12.1501 13.25 12.8502 13.5225 13.385C13.7622 13.8554 14.1446 14.2378 14.615 14.4775C15.1498 14.75 15.8499 14.75 17.25 14.75H18.75C20.1501 14.75 20.8502 14.75 21.385 14.4775C21.8554 14.2378 22.2378 13.8554 22.4775 13.385C22.75 12.8502 22.75 12.1501 22.75 10.75V5.25C22.75 3.84987 22.75 3.1498 22.4775 2.61502C22.2378 2.14462 21.8554 1.76217 21.385 1.52248C20.8502 1.25 20.1501 1.25 18.75 1.25H17.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 10V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.07989 2 5.2 2H6.8C7.92011 2 8.48016 2 8.90798 2.21799C9.28431 2.40973 9.59027 2.71569 9.78201 3.09202C10 3.51984 10 4.07989 10 5.2V18.8C10 19.9201 10 20.4802 9.78201 20.908C9.59027 21.2843 9.28431 21.5903 8.90798 21.782C8.48016 22 7.92011 22 6.8 22H5.2C4.07989 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V14M17.2 14H18.8C19.9201 14 20.4802 14 20.908 13.782C21.2843 13.5903 21.5903 13.2843 21.782 12.908C22 12.4802 22 11.9201 22 10.8V5.2C22 4.0799 22 3.51984 21.782 3.09202C21.5903 2.7157 21.2843 2.40974 20.908 2.21799C20.4802 2 19.9201 2 18.8 2H17.2C16.0799 2 15.5198 2 15.092 2.21799C14.7157 2.40974 14.4097 2.7157 14.218 3.09202C14 3.51984 14 4.0799 14 5.2V10.8C14 11.9201 14 12.4802 14.218 12.908C14.4097 13.2843 14.7157 13.5903 15.092 13.782C15.5198 14 16.0799 14 17.2 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.07989 2 5.2 2H6.8C7.92011 2 8.48016 2 8.90798 2.21799C9.28431 2.40973 9.59027 2.71569 9.78201 3.09202C10 3.51984 10 4.07989 10 5.2V18.8C10 19.9201 10 20.4802 9.78201 20.908C9.59027 21.2843 9.28431 21.5903 8.90798 21.782C8.48016 22 7.92011 22 6.8 22H5.2C4.07989 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V5.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 5.2C14 4.07989 14 3.51984 14.218 3.09202C14.4097 2.71569 14.7157 2.40973 15.092 2.21799C15.5198 2 16.0799 2 17.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V10.8C22 11.9201 22 12.4802 21.782 12.908C21.5903 13.2843 21.2843 13.5903 20.908 13.782C20.4802 14 19.9201 14 18.8 14H17.2C16.0799 14 15.5198 14 15.092 13.782C14.7157 13.5903 14.4097 13.2843 14.218 12.908C14 12.4802 14 11.9201 14 10.8V5.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M17.25 1.25C15.8499 1.25 15.1498 1.25 14.615 1.52248C14.1446 1.76217 13.7622 2.14462 13.5225 2.61502C13.25 3.1498 13.25 3.84987 13.25 5.25V10.75C13.25 12.1501 13.25 12.8502 13.5225 13.385C13.7622 13.8554 14.1446 14.2378 14.615 14.4775C15.1498 14.75 15.8499 14.75 17.25 14.75H18.75C20.1501 14.75 20.8502 14.75 21.385 14.4775C21.8554 14.2378 22.2378 13.8554 22.4775 13.385C22.75 12.8502 22.75 12.1501 22.75 10.75V5.25C22.75 3.84987 22.75 3.1498 22.4775 2.61502C22.2378 2.14462 21.8554 1.76217 21.385 1.52248C20.8502 1.25 20.1501 1.25 18.75 1.25H17.25Z"
				fill="currentColor"
			/>
			<path
				d="M1.25 5.25C1.25 3.84987 1.25 3.1498 1.52248 2.61502C1.76217 2.14462 2.14462 1.76217 2.61502 1.52248C3.1498 1.25 3.84987 1.25 5.25 1.25H6.75C8.15013 1.25 8.8502 1.25 9.38498 1.52248C9.85538 1.76217 10.2378 2.14462 10.4775 2.61502C10.75 3.1498 10.75 3.84987 10.75 5.25V18.75C10.75 20.1501 10.75 20.8502 10.4775 21.385C10.2378 21.8554 9.85538 22.2378 9.38498 22.4775C8.8502 22.75 8.15013 22.75 6.75 22.75H5.25C3.84987 22.75 3.1498 22.75 2.61502 22.4775C2.14462 22.2378 1.76217 21.8554 1.52248 21.385C1.25 20.8502 1.25 20.1501 1.25 18.75V5.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
